import Roles from './../components/AppParametros/Roles.jsx';
import CambiarPassword from './../components/AppParametros/AdministrarUsuarios/CambiarPassword.jsx';
import Entidades from './../components/AppParametros/Entidades.jsx';
import Componentes from './../components/AppParametros/Componentes.jsx';
import Estadosusuario from './../components/AppParametros/Estadosusuario.jsx';
import Usuarios from './../components/AppParametros/Usuarios.jsx';
import Actividades from './../components/AppParametros/Actividades.jsx';
import Discapacidades from './../components/AppParametros/Discapacidades.jsx';
import Causadiscapacidad from './../components/AppParametros/Causadiscapacidad.jsx';
import Sexos from './../components/AppParametros/Sexos.jsx';
import Minorias from './../components/AppParametros/Minorias.jsx';
import Entidadeseducativas from './../components/AppParametros/Entidadeseducativas.jsx';
import EstadosCivil from './../components/AppParametros/EstadosCivil.jsx';
import Programasespeciales from './../components/AppParametros/Programasespeciales.jsx';
import Oficios from './../components/AppParametros/Oficios.jsx';
import Programasdiscapacidad from './../components/AppParametros/Programasdiscapacidad.jsx';
import Razonesnoestudio from './../components/AppParametros/Razonesnoestudio.jsx';
import Salud from './../components/AppParametros/Salud.jsx';
import Tiposestudio from './../components/AppParametros/Tiposestudio.jsx';
import Tiposidentificacion from './../components/AppParametros/Tiposidentificacion.jsx';
import Departamentos from './../components/AppParametros/Departamentos.jsx';
import Municipios from './../components/AppParametros/Municipios.jsx';
import Sedes from './../components/AppParametros/Sedes.jsx';
import TipoAtencion from './../components/AppParametros/TipoAtencion.jsx';
import Ayudas from './../components/AppParametros/Ayudas.jsx';
import Zonas from './../components/AppParametros/Zonas.jsx';
import Comunas from './../components/AppParametros/Comunas.jsx';
import OrientacionSexual from './../components/AppParametros/OrientacionSexual.jsx';
import Barrios from './../components/AppParametros/Barrios.jsx';
import IdentidadGenero from './../components/AppParametros/IdentidadGenero.jsx';
import TipoHabitanteCalle from './../components/AppParametros/TipoHabitanteCalle.jsx';
import TiposEstrato from './../components/AppParametros/TiposEstrato.jsx';
import AyudasRol from './../components/AppParametros/AyudasPorRol.jsx';
import HechosVictimizantesParam from './../components/AppParametros/HechosVictimizantesParam.jsx';
import Razonnosalud from './../components/AppParametros/Razonnosalud.jsx';
import TiposAyudas from './../components/AppParametros/TiposAyudas.jsx';
import TiposAtenciones from './../components/AppParametros/TiposAtenciones.jsx';
import TipoEntregaxTipoAhu from './../components/AppParametros/TipoEntregaxTipoAhu.jsx';
import TipoNaturalezaxTipoentrega from './../components/AppParametros/TipoNaturalezaxTipoentrega.jsx';
import TipoEventos from './../components/AppParametros/Organizaciones/TipoEventos.jsx';
import TipoActividades from './../components/AppParametros/Organizaciones/TipoActividades.jsx';
import LineasAccion from './../components/AppParametros/Organizaciones/LineasAccion.jsx';
import TipoSubactividades from '../components/AppParametros/Organizaciones/TipoSubactividades.jsx';
import Asentamientos from '../components/AppParametros/Asentamientos.jsx';
import IngresosEconomicos from '../components/AppParametros/IngresosEconomicos.jsx';
import ModalidadHomicidios from '../components/AppParametros/ModalidadHomicidios.jsx';
import MedioHomicidio from '../components/AppParametros/MedioHomicidio.jsx';
import PresuntosVictimarios from '../components/AppParametros/PresuntosVictimarios.jsx';
import TipoReporteSeguimiento from '../components/AppParametros/TipoReporteSeguimiento.jsx';
import EstadosCaso from '../components/AppParametros/EstadosCaso.jsx';
import CondicionesMigratorias from '../components/AppParametros/CondicionesMigratorias.jsx';
import TipoAtencionDdhh from '../components/AppParametros/TipoAtencionDdhh.jsx';
import TipoVulneracionDdhh from '../components/AppParametros/TipoVulneracionDdhh.jsx';
import EntidadRelacionDDHH from '../components/AppParametros/EntidadRelacionDDHH.jsx';
import TiposTrata from '../components/AppParametros/TiposTrata.jsx';
import TipoQuienBrindaInfo from '../components/AppParametros/TipoQuienBrindaInfo.jsx'; 
import PerfilesVictima from '../components/AppParametros/PerfilesVictima.jsx';
import EsquemaSeguridad from '../components/AppParametros/EsquemaSeguridad.jsx';
import EstadoBusqueda from '../components/AppParametros/EstadoBusqueda.jsx';
import ModalidadDesaparicion from '../components/AppParametros/ModalidadDesaparicion.jsx';
import FuenteInformacion from '../components/AppParametros/FuenteInformacion.jsx';
import PosiblesCausas from '../components/AppParametros/PosiblesCausas.jsx';
import ModalidadReclutamiento from '../components/AppParametros/ModalidadReclutamiento.jsx';
import LineasVulnerabilidadddhh from '../components/AppParametros/LineasVulnerabilidaddhh.jsx';
import AtencionesxRolddhh from '../components/AppParametros/AtencionesxRolddhh.jsx';
import Parentescos from '../components/AppParametros/Parentescos.jsx';
import UpTipoAcompanamiento from '../components/AppParametros/Uptipoacompanamiento.jsx';
import UpTipoIniciativa from '../components/AppParametros/Uptipoiniciativa.jsx';
import UpNaturalezaJuridica from '../components/AppParametros/Upnaturalezajuridica.jsx';
import UpUbicacionIniciativa from '../components/AppParametros/Upubicacioniniciativa.jsx';
import UpTipoTenencia from '../components/AppParametros/Uptipotenencia.jsx';
import UpRangoTiempo from '../components/AppParametros/Uprangotiempo.jsx';
import Tiposinona from '../components/AppParametros/Tiposinona.jsx';


export const ParametrosRoutes = [
    { path: '/parametros/roles', element: <Roles /> },
    { path: 'cambiarpassword', element: <CambiarPassword /> },
    { path: 'parametros/entidades', element: <Entidades /> },
    { path: 'parametros/componentes', element: <Componentes /> },
    { path: 'parametros/estadosusuario', element: <Estadosusuario /> },
    { path: 'parametros/usuarios', element: <Usuarios /> },
    { path: 'parametros/actividades', element: <Actividades /> },
    { path: 'parametros/discapacidades', element: <Discapacidades /> },
    { path: 'parametros/causadiscapacidad', element: <Causadiscapacidad /> },
    { path: 'parametros/sexos', element: <Sexos /> },
    { path: 'parametros/minorias', element: <Minorias /> },
    { path: 'parametros/entidadeseducativas', element: <Entidadeseducativas /> },
    { path: 'parametros/estadoscivil', element: <EstadosCivil /> },
    { path: 'parametros/programasespeciales', element: <Programasespeciales /> },
    { path: 'parametros/oficios', element: <Oficios /> },
    { path: 'parametros/programasdiscapacidad', element: <Programasdiscapacidad /> },
    { path: 'parametros/razonesnoestudio', element: <Razonesnoestudio /> },
    { path: 'parametros/razonesnosalud', element: <Razonnosalud /> },
    { path: 'parametros/salud', element: <Salud /> },
    { path: 'parametros/tiposestudio', element: <Tiposestudio /> },
    { path: 'parametros/tiposidentificacion', element: <Tiposidentificacion /> },
    { path: 'parametros/departamentos', element: <Departamentos /> },
    { path: 'parametros/municipios', element: <Municipios /> },
    { path: 'parametros/sedes', element: <Sedes /> },
    { path: 'parametros/tiposatencion', element: <TipoAtencion /> },
    { path: 'parametros/tipoentregaxtipoahu', element: <TipoEntregaxTipoAhu /> },
    { path: 'parametros/tiponaturalezaxtipoentrega', element: <TipoNaturalezaxTipoentrega /> },
    { path: 'parametros/tiposayudas', element: <TiposAyudas /> },
    { path: 'parametros/tiposatenciones', element: <TiposAtenciones /> },
    { path: 'parametros/ayudas', element: <Ayudas /> },
    { path: 'parametros/zonas', element: <Zonas /> },
    { path: 'parametros/comunas', element: <Comunas /> },
    { path: 'parametros/orientacionsexual', element: <OrientacionSexual /> },
    { path: 'parametros/barrios', element: <Barrios /> },
    { path: 'parametros/asentamientos', element: <Asentamientos /> },
    { path: 'parametros/identidadgenero', element: <IdentidadGenero /> },
    { path: 'parametros/tiposhabitantecalle', element: <TipoHabitanteCalle /> },
    { path: 'parametros/tiposestrato', element: <TiposEstrato /> },
    { path: 'parametros/ayudasporrol', element: <AyudasRol /> },
    { path: 'parametros/hechosvictimizantes', element: <HechosVictimizantesParam /> },
    { path: 'parametros/tipoeventos', element: <TipoEventos /> },
    { path : 'parametros/tipoactividades', element: <TipoActividades /> },
    { path : 'parametros/lineasaccion', element: <LineasAccion /> },
    { path : 'parametros/subactividades', element: <TipoSubactividades /> },
    { path : 'parametros/ingresoseconomicos', element: <IngresosEconomicos /> },
    { path : 'parametros/modalidadhomicidios', element: <ModalidadHomicidios /> },
    { path : 'parametros/mediohomicidios', element: <MedioHomicidio /> },
    { path : 'parametros/presuntosvictimarios', element: <PresuntosVictimarios /> },
    { path : 'parametros/tiporeporteseguimiento', element: <TipoReporteSeguimiento /> },
    { path : 'parametros/estadocaso', element: <EstadosCaso /> },
    { path : 'parametros/condicionesmigratorias', element: <CondicionesMigratorias /> },
    { path : 'parametros/tipoatencionddhh', element: <TipoAtencionDdhh /> },
    { path : 'parametros/tipovulneracionddhh', element: <TipoVulneracionDdhh /> },
    { path : 'parametros/entidadrelacionddhh', element: <EntidadRelacionDDHH /> },
    { path : 'parametros/tipostrata', element: <TiposTrata /> },
    { path : 'parametros/tipoquienbrindainfo', element: <TipoQuienBrindaInfo /> },
    { path : 'parametros/perfilesvictima', element: <PerfilesVictima /> },
    { path : 'parametros/esquemasseguridad', element: <EsquemaSeguridad /> },
    { path : 'parametros/estadobusqueda', element: <EstadoBusqueda /> },
    { path : 'parametros/modalidaddesaparicion', element: <ModalidadDesaparicion /> },
    { path : 'parametros/fuenteinformacion', element: <FuenteInformacion /> },
    { path : 'parametros/posiblescausas', element: <PosiblesCausas /> },
    { path : 'parametros/modalidadreclutamiento', element: <ModalidadReclutamiento /> },
    { path : 'parametros/lineasvulnerabilidad', element: <LineasVulnerabilidadddhh /> },
    { path : 'parametros/tipoatencionxrol', element: <AtencionesxRolddhh /> },
    { path : 'parametros/parentescos', element: <Parentescos /> },
    { path : 'parametros/tipoacompanamiento', element: <UpTipoAcompanamiento /> },
    { path : 'parametros/tipoiniciativa', element: <UpTipoIniciativa /> },
    { path : 'parametros/naturalezajuridica', element: <UpNaturalezaJuridica /> },
    { path : 'parametros/upubicacioniniciativa', element: <UpUbicacionIniciativa /> },
    { path : 'parametros/uptipotenencia', element: <UpTipoTenencia /> },
    { path : 'parametros/uprangotiempo', element: <UpRangoTiempo /> },
    { path : 'parametros/tiposinona', element: <Tiposinona /> },
];